/** Placeholder for a column with nothing to show for a given user. */
const EMPTY_VALUE = '—';

export default EMPTY_VALUE;
